module.exports = __webpack_public_path__ + "img/antimatter-energy-fuel.e5972353.png";